import React from 'react';
import { FormDinamico } from './FormDinamico';

const ContactForm = () => {
  return (
    <section id="contatti" className="py-20 bg-gradient-to-b from-[#1B2380] to-[#10154F] relative overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#0E8C84]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#0E8C84]/10 rounded-full blur-3xl"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12 animate-fade-in-up">
          <span className="inline-block px-4 py-2 bg-white/10 backdrop-blur-md text-white rounded-full text-sm font-semibold mb-4 border border-white/20">
            Diagnosi di Sostenibilità Assicurativa
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            Proteggi il tuo ente,{' '}
            <span className="text-[#8FE3DA]">inizia oggi</span>
          </h2>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            Compila il form per richiedere una Diagnosi di Sostenibilità Assicurativa gratuita. 
            Ti ricontatteremo entro 24 ore.
          </p>
        </div>

        {/* Form */}
        <div className="bg-white/95 backdrop-blur-xl rounded-2xl p-8 sm:p-12 shadow-2xl animate-fade-in-up" style={{ animationDelay: '0.2s' }} data-testid="contact-form-card">
          <FormDinamico formKey="contatto" />
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
